//  Show/hide password using single <img> tag

function togglePassword(el) {
  const input = el.previousElementSibling;
  const icon = el.querySelector('img');
  if (!input || !icon) return;

  const isVisible = icon.dataset.visible === "true";
  input.type = isVisible ? "password" : "text";
  icon.src = isVisible ? el.dataset.off : el.dataset.on;
  icon.dataset.visible = isVisible ? "false" : "true";
}
// globly using 
function getFormControlElement(el) {
  // If it's an input/select/textarea, return it directly
  if (el.matches('input, select, textarea')) return el;

  // Otherwise try to find the form control inside it
  return el.querySelector('input, select, textarea');
}

// global password validation
function passwordValidationRegex(value){
    const minLength = 8;
    const hasLetter = /[a-zA-Z]/;
    const hasNumber = /[0-9]/;
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
if(value.length < minLength || !hasLetter.test(value) || !hasNumber.test(value) || !hasSpecialChar.test(value)){
  return false;
}
return true;
}
// using globly 
function showError(input, key) {
  const row = input.closest('.field_row');
  if (!row) return;

  const errors = row.querySelectorAll('.error_message');
  const success = row.querySelector('.success_message');

  let hasError = false;

  errors.forEach(err => {
    const show = err.dataset.error === key;
    err.style.display = show ? 'block' : 'none';
    if (show) hasError = true;
  });

  const control = getFormControlElement(input);
  if (hasError && control) {
    control.classList.add('input_error');
  }

  if (success) success.style.display = 'none';
}
//  Show success
// using globly
function showSuccess(input) {
  const row = input.closest('.field_row');
  if (!row) return;

  row.querySelectorAll('.error_message').forEach(el => el.style.display = 'none');
  const success = row.querySelector('.success_message');
  if (success) success.style.display = 'block';

  const control = getFormControlElement(input);
  if (control) {
    control.classList.remove('input_error');
  }
}

function clearMessages(input) {
  const row = input.closest('.field_row');
  if (!row) return;

  row.querySelectorAll('.error_message, .success_message').forEach(el => el.style.display = 'none');

  const control = getFormControlElement(input);
  if (control) {
    
    control.classList.remove('input_error');
  }
}

//  Email Validator
function isValidEmail(email) {
  return /^\S+@\S+\.\S+$/.test(email);
}

function validatePasswordField(passwordInput) {
  const value = passwordInput.value.trim();
  const row = passwordInput.closest('.field_row');
  const errorBox = row?.querySelector('[data-error="invalid"]');
  const successBox = row?.querySelector('.success_message');
  const errorBoxempty = row?.querySelector('[data-error="empty"]');
    console.log('typed----- passwordInput',value,passwordInput);

  if (!row || !errorBoxempty || !successBox) return false;

   if(!value) {
    errorBoxempty.dataset.error = "empty"; // make sure the key matches!
    showError(passwordInput, 'empty'); // this adds `input_error`
    console.log('passwordInput',passwordInput);
    return false;
   }

  // if (messages.length > 0) {
  if (!passwordValidationRegex(value)) {
    // errorBox.textContent = `Password must be ${messages.join(", ")}`;
    // errorBox.dataset.error = "invalid"; // make sure the key matches!
    showError(passwordInput, 'invalid'); // this adds `input_error`
    return false;
  } else {
    showSuccess(passwordInput); // this removes `input_error`
    return true;
  }
}

function initAuthValidation() {
  const forms = document.querySelectorAll('form');
  const blackListedEmails = window?.customerData?.blacklistedEmail || [];
  //if(Array.isArray(blackListedEmails) && blackListedEmails.length > 0) {
  //  console.log("blacklisted emails are visible here",blackListedEmails);
  //}

  forms.forEach(form => {
    const emailInput = form.querySelector('.email_input');
    const passwordInput = form.querySelector('.password_input');
    const formBtn = form.querySelector('.form_button');
    
    //Email Validation
    if (emailInput) {
      emailInput.addEventListener('blur', function () {
        const value = emailInput.value.trim();
        if (!value) {
          showError(emailInput, 'empty');
        } else if (!isValidEmail(value)) {
          showError(emailInput, 'invalid');
        } else {
        console.log("in else condition blacklisted email");
        const emailDomain = value.split("@")[1]?.toLowerCase();
        if (blackListedEmails?.includes(emailDomain)) {
          console.log("email contains blacklisted domain");
          showError(emailInput, 'blacklisted');
         if (formBtn)  formBtn.disabled = true
        } else {
          console.log("showing success message in email");
          showSuccess(emailInput,'succ_mess');
         if (formBtn)  formBtn.disabled = false
        }
      }
      });
      emailInput.addEventListener('input', () => clearMessages(emailInput));
    }

    //Password Validation
    if (passwordInput) {
      passwordInput.addEventListener('blur', () => validatePasswordField(passwordInput));
      passwordInput.addEventListener('input', () => {
        clearMessages(passwordInput);
        validatePasswordField(passwordInput);
      });
    }

    // Submit Handling
    form.addEventListener('submit', function (e) {
      let hasError = false;

      if (emailInput) {
        const value = emailInput.value.trim();
        const emailDomain = value.split("@")[1]?.toLowerCase();
        if (!value) {
          showError(emailInput, 'empty');
          hasError = true;
        } else if (!isValidEmail(value)) {
          showError(emailInput, 'invalid');
          hasError = true;
        } else if (blackListedEmails.includes(emailDomain)) {
          console.log("in submit button conatins blacklisted domain");
          showError(emailInput, 'blacklisted'); 
          hasError = true; 
        }else {
          showSuccess(emailInput);
        }
      }

      if (passwordInput) {
        const isValid = validatePasswordField(passwordInput);
        if (!isValid) hasError = true;
      }

      // Flag attempt for Shopify error catch
      if (!hasError && form.action.includes('/account/login')) {
        localStorage.setItem('auth_attempted', 'true');
      }

      if (hasError) {
        e.preventDefault();
      }
    });
  });
}

//  DOM Ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAuthValidation);
} else {
  initAuthValidation();
}
// Handle Shopify Login Redirect Error (Stay on popup)
// After initAuthValidation setup
function showShopifyLoginErrorIfNeeded() {
  const params = new URLSearchParams(window.location.search);
  const attempted = localStorage.getItem('auth_attempted') === 'true';
  if (attempted && params.has('error')) {
    localStorage.removeItem('auth_attempted');
    openAuthPopup();
    switchAuthForm('login');

    const emailRow = document.querySelector('#CustomerEmail').closest('.field_row');
    if (emailRow) {
      emailRow.querySelectorAll('.shopify_error_message').forEach(el => el.remove());
      const errorEl = document.createElement('div');
      errorEl.className = 'error_message shopify_error_message';
      errorEl.textContent = decodeURIComponent(params.get('error')).replace(/\+/g, ' ');
      emailRow.appendChild(errorEl);
    }
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}
document.addEventListener('DOMContentLoaded', showShopifyLoginErrorIfNeeded);
document.addEventListener("DOMContentLoaded", async () => {

    // login 
    document.getElementById('LoginForm')?.addEventListener('submit', function () {
        sessionStorage.setItem('loginFlag', '1');
        // remove sinup on login
        sessionStorage.removeItem('signupFlag');
    });
    // sing up 
    document.getElementById('RegisterForm')?.addEventListener('submit', function () {
        sessionStorage.setItem('signupFlag', '1');
        // remove sinin on login
        sessionStorage.removeItem('loginFlag');
    });
    // for otp 
    let inputs = document.querySelectorAll('.code-input');
    let enable_delete_btn = document.querySelector('.enable_delete_btn');
    let enable_e_mail_btn = document.querySelector('.enable_e_mail_btn');
    // this is for delete popup
    if(enable_delete_btn){
    enable_delete_btn.disabled = true;
    inputs.forEach((input, index) => {
        input.addEventListener('input', () => {
            // Allow only digits
            input.value = input.value.replace(/[^0-9]/g, '');
            // Move to next field
            if (input.value.length === 1 && index < inputs.length - 1) {
                inputs[index + 1].focus();
            }
            // Count how many inputs are filled
            let filledCount = Array.from(inputs).filter(inp => inp.value.length === 1).length;
            // Enable only if first 6 inputs are filled
            console.log(filledCount, 'filledCount');
            if (filledCount >= 6) {
                enable_delete_btn.disabled = false;
            } else {
                enable_delete_btn.disabled = true;
            }
        });
        input.addEventListener('keydown', (e) => {
            if (e.key === 'Backspace' && input.value === '' && index > 0) {
                inputs[index - 1].focus();
            }
        });
    });
    }
    if(enable_e_mail_btn){
       enable_e_mail_btn.disabled = true;
    inputs.forEach((input, index) => {
        input.addEventListener('input', () => {
            // Allow only digits
            input.value = input.value.replace(/[^0-9]/g, '');
            // Move to next field
            if (input.value.length === 1 && index < inputs.length - 1) {
                inputs[index + 1].focus();
            }
            // Count how many inputs are filled
            let filledCount = Array.from(inputs).filter(inp => inp.value.length === 1).length;
            // Enable only if first 6 inputs are filled
            console.log(filledCount, 'filledCount');
            if (filledCount >= 6) {
                enable_e_mail_btn.disabled = false;
            } else {
                enable_e_mail_btn.disabled = true;
            }
        });
        input.addEventListener('keydown', (e) => {
            if (e.key === 'Backspace' && input.value === '' && index > 0) {
                inputs[index - 1].focus();
            }
        });
    });
    }
   
});
